import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser, faChevronDown, faRightFromBracket, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import api from '../api/client';
import ProfileModal from './ProfileModal';
import '../profile-menu.css';

function ProfileMenu({ onLogout }) {
    const [profile, setProfile] = useState(null);
    const [open, setOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        api.get(`/api/profile`)
            .then(r => setProfile(r.data))
            .catch(() => {});
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const closePanel = () => { setOpen(false); setModalOpen(false); };
        window.addEventListener('header:closeMobileMenu', closePanel);
        return () => window.removeEventListener('header:closeMobileMenu', closePanel);
    }, []);

    const displayName = profile?.employeeName || 'Account';

    return (
        <div className="profile-menu" ref={containerRef}>
            <button type="button" className="profile-menu__trigger" onClick={() => setOpen(o => !o)}>
                <FontAwesomeIcon icon={faCircleUser} className="profile-menu__avatar" />
                <span className="profile-menu__name">{displayName}</span>
                <FontAwesomeIcon icon={faChevronDown} className="profile-menu__chevron" />
            </button>

            {open && (
                <div className="profile-menu__panel">
                    <button
                        type="button"
                        className="profile-menu__item"
                        onClick={() => { setModalOpen(true); setOpen(false); }}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                        Edit Profile
                    </button>
                    <button
                        type="button"
                        className="profile-menu__item profile-menu__item--danger"
                        onClick={onLogout}
                    >
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        Log Out
                    </button>
                </div>
            )}

            {modalOpen && (
                <ProfileModal
                    profile={profile}
                    onClose={() => setModalOpen(false)}
                    onSaved={(updated) => setProfile(p => ({ ...p, ...updated }))}
                />
            )}
        </div>
    );
}

export default ProfileMenu;
